import { LOCAL_STORAGE_KEYS } from "../constants/localStorageKeys.constant";
import axios, { AxiosInstance } from "axios";

const axiosClient: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 90000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json, text/plain, */*",
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
  },
});

axiosClient.interceptors.request.use(
  async (config) => {
    try {
      const accessToken = localStorage.getItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
      if (accessToken && config.headers) {
        config.headers.Authorization = ` ${accessToken}`;
      }

      if (config.headers) {
        config.headers["Origin"] = window.location.origin;
        config.headers["Referer"] = window.location.origin + "/";
      }

      return config;
    } catch (error) {
      console.error("Request interceptor error:", error);
      return config;
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
      localStorage.removeItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN_EXP);
      localStorage.removeItem(LOCAL_STORAGE_KEYS.REFRESH_TOKEN);
      window.location.href = "/";
    }
    return Promise.reject(error?.response || error);
  }
);

export default axiosClient;
